import { render, staticRenderFns } from "./AddPermission.vue?vue&type=template&id=3b51aae0&"
import script from "./AddPermission.vue?vue&type=script&lang=js&"
export * from "./AddPermission.vue?vue&type=script&lang=js&"
import style0 from "./AddPermission.vue?vue&type=style&index=0&id=3b51aae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports